/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import { RegistrationDrawer } from './RegistrationDrawer';
import { AddressDrawer } from './AddressDrawer';
import { DescriptionDrawer } from './DescriptionDrawer';

interface ProfileEditDrawersProps {
  drawerOpen: boolean;
  setDrawerOpen: (v: boolean) => void;
  addressDrawerOpen: boolean;
  setAddressDrawerOpen: (v: boolean) => void;
  descriptionDrawerOpen: boolean;
  setDescriptionDrawerOpen: (v: boolean) => void;
}

/**
 * Renders the registration, address, and description edit drawers for the
 * profile section.
 *
 * @param props - The edit drawers props.
 * @param props.drawerOpen - Whether the registration drawer is open.
 * @param props.setDrawerOpen - Setter to toggle the registration drawer.
 * @param props.addressDrawerOpen - Whether the address drawer is open.
 * @param props.setAddressDrawerOpen - Setter to toggle the address drawer.
 * @param props.descriptionDrawerOpen - Whether the description drawer is open.
 * @param props.setDescriptionDrawerOpen - Setter to toggle the description drawer.
 * @returns The edit drawers element.
 */
export function ProfileEditDrawers({
  drawerOpen,
  setDrawerOpen,
  addressDrawerOpen,
  setAddressDrawerOpen,
  descriptionDrawerOpen,
  setDescriptionDrawerOpen,
}: ProfileEditDrawersProps) {
  return (
    <>
      <RegistrationDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
      <AddressDrawer open={addressDrawerOpen} onClose={() => setAddressDrawerOpen(false)} />
      <DescriptionDrawer
        open={descriptionDrawerOpen}
        onClose={() => setDescriptionDrawerOpen(false)}
      />
    </>
  );
}
